export const RDX_SESSION_LOCALE_UPDATE = 'rdx/session/locale/update';
export const RDX_SESSION_INIT = 'rdx/session/init';
export const RDX_SESSION_INIT_DONE = 'rdx/session/init/done';
export const RDX_SESSION_UPDATE = 'rdx/session/update';
export const RDX_CUSTOMER_UPDATE = 'rdx/customer/update';
export const RDX_RESPONSE_UPDATE = 'rdx/response/update';
export const RDX_HEADER_UPDATE = 'rdx/header/update';
export const RDX_GROUP_CODE_UPDATE = 'rdx/group/code/update';

export const changeLocale = (newLocale) => {
  return {type: RDX_SESSION_LOCALE_UPDATE, localeIntl: newLocale};
};
export const initSession = (key) => {
  return {
    type: RDX_SESSION_INIT,
    initKey: key,
  };
};
export const initSessionDone = () => {
  return {
    type: RDX_SESSION_INIT_DONE,
  };
};
export const updateSession = (jsonO) => {
  return {
    type: RDX_SESSION_UPDATE,
    jsonO: jsonO,
  };
};

export const updateCustomer = (data) => {
  return {
    type: RDX_CUSTOMER_UPDATE,
    data: data,
  };
};

export const updateHeader = (data) => {
  return {
    type: RDX_HEADER_UPDATE,
    data: data,
  };
};

export const updateResponse = (data) => {
  return {
    type: RDX_RESPONSE_UPDATE,
    data: data,
  };
};

export const updateGroupCode = (data) => {
  return {
    type: RDX_GROUP_CODE_UPDATE,
    data: data,
  };
};
